export enum PerformanceLevel {
  ProductId = "productId",
  VariantId = "variantId",
  Category = "category",
  Color = "color",
  Size = "size",
}

export enum CollectionTableColumn {
  BelongingToCollection = "belonging to collection",
  Forecast = "collection forecast",
  PreOrders = "collection pre-orders",
  InboundPreOrders = "collection inbound pre-orders",
  PreOrdersWithoutInbound = "collection pre-orders without inbound",
  FuturePreOrders = "collection future pre-orders",
  Sales = "collection sales",
  SalesAmount = "collection sales amount",
  PreOrdersAmount = "collection pre-orders amount",
  Out = "collection out",
  PreOrdersComparison = "collection pre-orders comparison",
  InboundPreOrdersComparison = "collection inbound pre-orders comparison",
  PreOrdersWithoutInboundComparison = "collection pre-orders without inbound comparison",
  SalesComparison = "collection sales comparison",
  ForecastComparison = "collection forecast comparison",
  ProjectedSales = "collection projected sales",
  ProjectedSalesComparison = "collection projected sales comparison",
  ProjectedSalesWithoutPreOrders = "collection projected sales without pre-orders",
  ProjectedStockLevel = "collection projected stock level",
  ProjectedInventoryValue = "collection projected inventory value",
  IncomingOrders = "collection purchase orders",
  IncomingOrdersComparison = "collection purchase orders comparison",
  Budget = "collection budget",
  SalesRisk = "collection sales risk",
  SalesRiskComparison = "collection sales risk comparison",
  ExpectedReturns = "collection expected returns",
}

/**
 * Every column `useCollectionTableColumns` can build. The collection-wide reads in
 * `useCollectionTableData` are only worth making when one of these is on screen.
 *
 * The whole enum rather than a hand-listed subset: the comparison ids are added conditionally, and a
 * list that drifted would silently starve a column of its data.
 */
export const COLLECTION_TABLE_COLUMN_IDS: ReadonlySet<string> = new Set(
  Object.values(CollectionTableColumn),
)
